module.exports = __webpack_public_path__ + "img/pharmacy.f77b67b1.png";